import {
  Component,
  ElementRef,
  AfterViewInit,
  OnInit,
  ViewContainerRef,
  Output,
  EventEmitter,
} from '@angular/core';
import {
  FormGroup,
  FormControl,
  Validators,
  ValidatorFn,
} from '@angular/forms';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { catchError, debounceTime, take, tap } from 'rxjs/operators';
import { from } from 'rxjs/observable/from';
import { environment } from '../../../../environments/environment';
import * as CodiceFiscale from 'codice-fiscale-js';
import {
  Onboarding,
  OnbValidators,
  Sex,
  Status,
} from '../../../models/onboarding';
import { ApiService } from '../../../services/api.service';
import { Product, ProductType } from '../../../models/product';
import { Source } from '../../../models/product';
import { LinkInfo } from '../../../models/link_info';
import { ModalDialogService } from 'ngx-modal-dialog';
import { AlgConditionModalComponent } from '../../dialogs/alg-condition-modal/alg-condition-modal.component';
import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { UtilsService } from '../../../services/utils.service';
import { AlgGtmService } from '../../../services/alg-gtm.service';
import { addIdToSelectInputElement } from '../../../utils/addIdToSelectInputElement';

import { GasUse } from '../../../models/onboarding';
import { AlgCfModalComponent } from '../../dialogs/alg-cf-modal/alg-cf-modal.component';
import { isUser75OrOlder, checkUserAgeByCf } from '../../../utils/cf';

@Component({
  selector: 'alg-supplies',
  templateUrl: './alg-supplies.component.html',
  styleUrls: ['./alg-supplies.component.scss'],
})
export class AlgSuppliesComponent implements OnInit, AfterViewInit {
  @Output() statusBack = new EventEmitter<string>();

  public suppliesForm: FormGroup;
  public fiscalControl: FormGroup;
  public product: Product;
  public onboarding: Onboarding = {} as Onboarding;
  public gasType: string;
  public isLight = false;
  public isGas = false;
  public goAhead: boolean;
  public cfControl: boolean;
  public goAheadAll: boolean = false;
  public productTypes = ProductType;
  public lightPOD: ValidatorFn[] = [Validators.maxLength(14)];
  public linkInfoDescription: string;
  public linkInfoLabel: string;
  public gasUploader: FileUploader;
  public lightUploader: FileUploader;
  public lightSuppliers: any[] = [];
  public lightPowers: any[] = [];
  public lightBillName: string;
  public lightBillUrl: string;
  public gasBillName: string;
  public gasBillUrl: string;
  public exampleDateFiscalCode: string;
  public isGasOrDual: boolean;
  public gasValid = true;
  public hasCorrectValue = false;
  public isFirstContract: boolean;
  public isAvailableCfService: boolean;
  public cfInvalidMessage: string = 'CF_INVALID';
  public productSource: string;

  private gas = {
    gasPDR: new FormControl(this.onboarding.gasPDR, {
      validators: [
        Validators.required,
        Validators.minLength(14),
        Validators.maxLength(14),
      ],
    }),
    gasConsumption: new FormControl(this.onboarding.gasConsumption, {
      validators: [Validators.required],
    }),
  };

  private luce = {
    lightSupplier: new FormControl(this.onboarding.lightSupplier, {
      validators: [Validators.required],
    }),
    lightPower: new FormControl(this.onboarding.lightPower, {
      validators: [Validators.required],
    }),
    lightConsumption: new FormControl(this.onboarding.lightConsumption, {
      validators: [Validators.required],
    }),
    lightPOD: new FormControl(this.onboarding.lightPOD, {
      validators: [
        Validators.required,
        Validators.pattern('^[I]{1}[T}]{1}[0-9]{3}[A-Z]{1}[0-9]{7}[0-9A-Z]{1}'),
      ],
    }),
  };

  constructor(
    private api: ApiService,
    private utils: UtilsService,
    private modalDialogService: ModalDialogService,
    private viewContainer: ViewContainerRef,
    private gtm: AlgGtmService,
    private el: ElementRef
  ) {}

  ngOnInit() {
    this.api.currentOnboarding
      .combineLatest(this.api.currentProduct)
      .subscribe(([onboarding, product]) => {
        this.setUploaders(onboarding);
        this.genFormControl(product);
        this.onboarding = onboarding;
        this.product = product;
        if (
          product.family &&
          product.family.name.toUpperCase() === 'CASA AGILE ECOLOGICA'
        ) {
          this.lightPowers = [
            '0,5',
            '1',
            '1,5',
            '2',
            '2,5',
            '3',
            '3,5',
            '4',
            '4,5',
            '5',
            '5,5',
            '6',
            '7',
            '8',
            '9',
            '10',
            '15',
            '20',
          ].map((n) => ({ label: n, value: `${n}kw` }));
        } else {
          this.lightPowers = [
            '1,5',
            '2',
            '2,5',
            '3',
            '3,5',
            '4',
            '4,5',
            '5',
            '5,5',
            '6',
            '7',
            '8',
            '9',
            '10',
            '15',
          ].map((n) => ({ label: n, value: `${n}kw` }));
        }
        if (this.product.family) {
          this.productSource = this.product.family.productSource;
        }
      });

    this.api.lightSuppliers.subscribe(
      (lightsuppliers) =>
        (this.lightSuppliers = lightsuppliers.map((e) => ({
          value: e.name,
          label: e.name,
        })))
    );

    this.api.getLightSuppliers();
    if (this.onboarding.gasConsumption) this.changeTypeGas();
    if (this.onboarding.lightSupplier) return (this.hasCorrectValue = true);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const selectFornitoreLight = document.getElementById(
        'select-fornitore-light'
      );
      const selectPotenzaLight = document.getElementById(
        'select-potenza-light'
      );
      if (selectFornitoreLight)
        addIdToSelectInputElement(
          'select-input-fornitore',
          selectFornitoreLight
        );
      if (selectPotenzaLight)
        addIdToSelectInputElement('select-input-potenza', selectPotenzaLight);
    }, 2000);
  }

  printFiles(files) {
    let text = '';
    files.forEach((item) => {
      text += item.file.name + ' ';
    });
    return text;
  }

  setUploaders(onboarding: Onboarding) {
    this.gasUploader = new FileUploader({
      url: `${environment.api.basePath}/upload-bills/${onboarding._id}`,
      itemAlias: 'gasBill',
      autoUpload: true,
    });
    this.lightUploader = new FileUploader({
      url: `${environment.api.basePath}/upload-bills/${onboarding._id}`,
      itemAlias: 'lightBill',
      autoUpload: true,
    });
    this.gasUploader.onAfterAddingFile = (file) => {
      file.withCredentials = false;
    };
    this.lightUploader.onAfterAddingFile = (file) => {
      file.withCredentials = false;
    };
    this.lightUploader.onCompleteItem = (file, response) => {
      if (response) {
        const res = JSON.parse(response);
        this.lightBillName = file.file.name;
        this.lightBillUrl = res.lightBill.url;
      }
    };

    this.gasUploader.onCompleteItem = (file, response) => {
      if (response) {
        const res = JSON.parse(response);
        this.gasBillName = file.file.name;
        this.gasBillUrl = res.gasBill.url;
      }
    };
  }

  openModal() {
    this.utils.disableOverflow();
    this.modalDialogService.openDialog(this.viewContainer, {
      title: LinkInfo(this.linkInfoLabel).title,
      childComponent: AlgConditionModalComponent,
      settings: {
        closeButtonClass: 'close theme-icon-close',
        headerTitleClass: ' modal-title modal-title-underline',
      },
      data: {
        description: this.linkInfoDescription,
      },
    });
    if (this.product.family.name.toUpperCase() === 'CASA AGILE ECOLOGICA') {
      this.lightPowers = [
        '0,5',
        '1',
        '1,5',
        '2',
        '2,5',
        '3',
        '3,5',
        '4',
        '4,5',
        '5',
        '5,5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '15',
        '20',
      ].map((n) => ({ label: n, value: `${n}kw` }));
    } else {
      this.lightPowers = [
        '1,5',
        '2',
        '2,5',
        '3',
        '3,5',
        '4',
        '4,5',
        '5',
        '5,5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '15',
      ].map((n) => ({ label: n, value: `${n}kw` }));
    }
  }

  public openCFModal() {
    if (!this.checkIfMobile()) {
      this.gtm.submitOnbEvent('Calcola codice fiscale');
    }
    this.utils.disableOverflow();
    this.modalDialogService.openDialog(this.viewContainer, {
      title: `Compila qua il tuo codice fiscale`,
      childComponent: AlgCfModalComponent,
      settings: {
        closeButtonClass: 'close theme-icon-close',
        headerTitleClass: ' modal-title modal-title-underline',
      },
      data: {
        onboarding: this.onboarding,
      },
    });
  }

  private checkIfMobile() {
    let check = false;
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor);
    return check;
  }

  openLink(index) {
    if (index === 1) {
      this.linkInfoLabel = 'potenza';
      this.linkInfoDescription = LinkInfo('potenza').description;
      this.gtm.submitOnbEvent('Click su link', 'potenza');
    } else if (index === 2) {
      this.linkInfoLabel = 'consumo_luce';
      this.linkInfoDescription = LinkInfo('consumo_luce').description;
      this.gtm.submitOnbEvent('Click su link', 'consumo luce');
    } else if (index === 3) {
      this.linkInfoLabel = 'pod';
      this.linkInfoDescription = LinkInfo('pod').description;
      this.gtm.submitOnbEvent('Click su link', 'pod');
    } else if (index === 4) {
      this.linkInfoLabel = 'pdr';
      this.linkInfoDescription = LinkInfo('pdr').description;
      this.gtm.submitOnbEvent('Click su link', 'pdr');
    } else {
      this.linkInfoLabel = 'consumo_gas';
      this.linkInfoDescription = LinkInfo('consumo_gas').description;
      this.gtm.submitOnbEvent('Click su link', 'consumo gas');
    }
    this.gtm.infoEvent();
    this.openModal();
  }
  private genFormControl(product: Product) {
    this.product = product;
    this.isLight = this.isGas = false;
    let fields = {};
    if (product.type === ProductType.luce) {
      this.isLight = true;
      fields = { ...fields, ...this.luce };
    }
    if (product.type === ProductType.gas) {
      this.isGas = true;
      fields = { ...fields, ...this.gas };
    }
    if (product.type === ProductType.luceEgas) {
      this.isLight = true;
      this.isGas = true;
      fields = { ...fields, ...this.luce, ...this.gas };
    }
    this.suppliesForm = new FormGroup(fields);
    this.fiscalControl = new FormGroup({
      fiscal: new FormControl(this.onboarding.cf, {
        validators: [
          Validators.required,
          OnbValidators.cf,
        ],
      }),
    });
    this.suppliesForm.statusChanges.subscribe((status) => {
      this.validateForm(product, status);
    });
    this.fiscalControl.statusChanges.subscribe((status) => {
      this.validateFormFiscal(status);
    });

  }

  validateForm(product: Product, status) {
    const gas =
      [ProductType.gas, ProductType.luceEgas].indexOf(product.type) !== -1;
    this.goAhead =
      status === 'VALID' && (gas ? this.gasType !== undefined : true);
    this.stepNextControl();
  }

  getContractsNumber() {
    this.isAvailableCfService=true;
    if(CodiceFiscale.check(this.onboarding.cf)) {
      this.cfInvalidMessage='';
      this.isFirstContract = false;
      return from(this.api.checkNumberContracts(this.onboarding.cf))
      .pipe(
        tap((res) => {
          if (res.esito === 'OK' && res.numero_contratti === 0) {
            this.isFirstContract = true;
          } else if (res.esito === 'OK' && res.numero_contratti > 0) {
            this.isFirstContract = false;
          } else {
            this.isAvailableCfService=false;
          }
        }),
        catchError((err) => {
          console.log({ err });
          throw err;
        })
      )
      .toPromise();
    }
  }

  addFormControls() {
    this.fiscalControl.get('fiscal').setValidators([
      Validators.required,
      OnbValidators.cf,
      OnbValidators.cfOnb(this.productSource, this.isFirstContract),
    ]);
  }

  repeatValidationUnicaCoopCf() {
    this.fiscalControl.get('fiscal').updateValueAndValidity();
  }

  public async checkCfAccendiUnicaCoop(source) {
    if(source===Source.accendiUnicaCoop) {
      await this.getContractsNumber();
      this.addFormControls();
    if(!CodiceFiscale.check(this.onboarding.cf) && this.isAvailableCfService) {
      this.cfInvalidMessage = 'CF_INVALID';
      this.cfControl = false;
      this.isFirstContract=false;
      return;
    } else if (!this.isFirstContract && CodiceFiscale.check(this.onboarding.cf) && this.isAvailableCfService) {
      this.cfInvalidMessage = 'CF_ACCENDI_UNICA_COOP_IVALID';
      this.cfControl = false;
    } else if (
      !CodiceFiscale.check(this.onboarding.cf) && this.isAvailableCfService
    ) {
      this.cfInvalidMessage = 'CF_INVALID';
      this.cfControl = false;
    } else if(this.isFirstContract && CodiceFiscale.check(this.onboarding.cf) && this.isAvailableCfService) {
      this.cfInvalidMessage = '';
      this.cfControl = true;
    } else if (!this.isAvailableCfService && CodiceFiscale.check(this.onboarding.cf)){
      this.cfControl = false;
      this.cfInvalidMessage = 'SERVICE_CHECK_CF_ACCENDI_UNICA_COOP';
    } else {
      return;
    }
    this.repeatValidationUnicaCoopCf();
    } else {
      return;
    }    
  }

  async validateFormFiscal(status: string) {
    this.cfControl = status === 'VALID';
    if (
      status === 'VALID' &&
      this.product.type !== ProductType.luce &&
      this.productSource !== Source.accendiUnicaCoop
    ) {
      this.api.isUser75YearsOld$.next(
        isUser75OrOlder(checkUserAgeByCf(this.onboarding.cf))
      );
      this.api.userFiscalCode$.next(this.onboarding.cf);
    }
    if (this.productSource === Source.accendiUnicaCoop) {
      this.api.userFiscalCode$.next(this.onboarding.cf);
    }
    this.stepNextControl();
  }

  stepNextControl() {
    if (this.cfControl && this.goAhead) {
      return (this.goAheadAll = true);
    } else {
      return (this.goAheadAll = false);
    }
  }

  changeTypeGas() {
    if (!this.onboarding.gasConsumption) return;
    const value = this.onboarding.gasConsumption;
    if (value < 500) {
      this.gasType = 'Cottura Cibi, Acqua Calda C2';
      this.onboarding.gasUse = GasUse.cottura;
    } else if (value >= 500 && value < 5000) {
      this.gasType = 'Riscaldamento, Cottura Cibi, Acqua Calda C3';
      this.onboarding.gasUse = GasUse.acqua;
    } else if (value >= 5000) {
      this.gasType = 'Solo Riscaldamento C1';
      this.onboarding.gasUse = GasUse.riscaldamento;
    }
    this.validateForm(this.product, this.suppliesForm.status);
  }

  public calculateSexfromCF() {
    const gender = this.onboarding.cf;
    let numberOfGender;
    numberOfGender = parseInt(gender.substring(9, 11));
    if (numberOfGender > 31) {
      this.onboarding.sex = Sex.female;
    } else {
      this.onboarding.sex = Sex.male;
    }
  }

  public nextStep() {
    this.markFormGroupTouched(this.suppliesForm);
    this.markFormGroupTouched(this.fiscalControl);
    this.calculateSexfromCF();
    const invalidControl =
      this.el.nativeElement.querySelector('form .ng-invalid');
    if (invalidControl) return this.scrollOnInvalidElement(invalidControl);

    if (!this.onboarding.lightConsumption) {
      this.onboarding.lightConsumption = '2300';
    }
    if (!this.gasType) {
      this.gasValid = false;
    } else {
      this.gasValid = true;
    }
    if (this.goAheadAll) {
      this.statusBack.emit('current');
      this.api.nextStep(this.onboarding, Status.supplies);
    }
  }

  public uploadFile(e, type) {
    this.gtm.submitOnbEvent(
      'Upload',
      type === 'gas' ? 'bolletta gas' : 'bolletta luce'
    );
    return;
  }

  public justNumber(event) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach((control) => {
      control.markAsTouched();
      if (control.controls) this.markFormGroupTouched(control);
    });
  }

  private scrollOnInvalidElement(invalidControl) {
    window.scroll({
      top: this.getTopOffset(invalidControl),
      left: 0,
      behavior: 'smooth',
    });

    fromEvent(window, 'scroll')
      .pipe(debounceTime(100), take(1))
      .subscribe(() => invalidControl.focus());
  }

  private getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 50;
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
  }

  changeStatus(value) {
    this.gtm.submitOnbEvent('clic su indietro', 'supplies');
    this.statusBack.emit(value);
  }

  checkLength(event, maxLength) {
    if (event.target.value.toString().length >= maxLength) {
      event.target.value.split(0, -1);
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/steps/alg-supplies/alg-supplies.component.ts